import { RevisarLoteHomePage } from '../pages/revisar-lote-home/revisar-lote-home';
import { ReceberLoteHomePage } from '../pages/receber-lote-home/receber-lote-home';
import { InspecionarLoteHomePage } from '../pages/inspecionar-lote-home/inspecionar-lote-home';
import { UsuarioHomePage } from '../pages/usuario-home/usuario-home';

//https://ionicframework.com/docs/v3/ionicons/

export class MenuHelper {
    private static _menuGerente: { icon: string, describe: string, page: any }[] = [
        { icon: 'redo', describe: 'Lotes Recebidos', page: ReceberLoteHomePage },
        { icon: 'md-contacts', describe: 'Gerenciar Usuário', page: UsuarioHomePage }    
    ];

    private static _menuInspetor: { icon: string, describe: string, page: any }[] = [
        { icon: 'clipboard', describe: 'Lote Revisado', page: InspecionarLoteHomePage }
    ];

    private static _menuRevisor: { icon: string, describe: string, page: any }[] = [
        { icon: 'clipboard', describe: 'Revisar Lote', page: RevisarLoteHomePage }
    ];

    public static getMenuToPrifile(profile: string): { icon: string, describe: string, page: any }[] {
        switch (profile) {
            case 'Gerente':
                return this._menuGerente;
            case 'Inspetor(a)':
                return this._menuInspetor;
            case 'Revisor(a)':
                return this._menuRevisor;
            default:
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/menu-helper.ts